import { combineReducers } from "redux";
import { authReducer } from "./auth/authReducer";
import { banHangReducer } from "./ban-hang/banHangReducer";
import { coSoReducer } from "./category/coSoReducer";
import { donViTinhReducer } from "./category/donViTinhReducer";
import { heReducer } from "./category/heReducer";
import { hinhThucThanhToanReducer } from "./category/hinhThucThanhToanReducer";
import { khoiReducer } from "./category/khoiReducer";
import { layoutReducer } from "./common/layoutReducer";
import { donHangChiTietReducer } from "./don-hang/donHangChiTietReducer";
import { donHangReducer } from "./don-hang/donHangReducer";
import { donHangViewChiTietReducer } from "./don-hang/donHangViewChiTietReducer";
import { emailPhuHuynhReducer } from "./don-hang/emailPhuHuynhReducer";
import { lopReducer } from "./category/lopReducer";
import { trangThaiKhoReducer } from "./quan-ly-kho/trangThaiKhoReducer";
import saleSetReducer from "./saleSet";
import { categoryReducer } from "./san-pham/categoryReducer";
import { sanPhamChiTietReducer } from "./san-pham/sanPhamChiTietReducer";
import { sanPhamReducer } from "./san-pham/sanPhamReducer";
import { namHocReducer } from "./category/namHocReducer";
import { setTieuChuanReducer } from "./set-tieu-chuan/setTieuChuanReducer";
import { setTieuChuanHocSinhReducer } from "./set-tieu-chuan/setTieuChuanHocSinhReducer";
import { setTieuChuanSanPhamReducer } from "./set-tieu-chuan/setTieuChuanSanPhamReducer";
import { khoReducer } from "./category/khoReducer";
import { nhapKhoReducer } from "./category/nhapKhoReducer";
import { tienThuaHocSinhReducer } from "./category/tienThuaHocSinhReducer";

const reducers = combineReducers({
  auth: authReducer,
  common: combineReducers({
    layout: layoutReducer,
  }),
  category: combineReducers({
    donViTinh: donViTinhReducer,
    hinhThucThanhToan: hinhThucThanhToanReducer,
    coSo: coSoReducer,
    he: heReducer,
    khoi: khoiReducer,
    lop: lopReducer,
    namHoc: namHocReducer,
    kho: khoReducer,
    nhapKho: nhapKhoReducer,
    tienThuaHocSinh: tienThuaHocSinhReducer
  }),
  sanPham: combineReducers({
    sanPHam: sanPhamReducer,
    sanPhamChiTiet: sanPhamChiTietReducer,
    category: categoryReducer
  }),
  banHang: banHangReducer,
  donHang: combineReducers({
    donHang: donHangReducer,
    donHangViewChiTiet: donHangViewChiTietReducer,
    donHangChiTiet: donHangChiTietReducer,
    emailPhuHuynh: emailPhuHuynhReducer
  }),
  setTieuChuan: combineReducers({
    setTieuChuan: setTieuChuanReducer,
    sanPham: setTieuChuanSanPhamReducer,
    hocSinh: setTieuChuanHocSinhReducer
  }),
  quanLyKho: combineReducers({
    trangThaiKho: trangThaiKhoReducer
  }),
  saleSet: saleSetReducer
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
